export default {
  name: `rotate_screen`,
  cta: `يرجى تدوير هاتفك`,
};
